<template>
    <div class="about">
      <video id="video" controls width="100%" class="about-video">
        <source src="https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/about.mov" type="video/mp4" />
      </video>
      <div class="about-item-1" id="explain">
        <div class="about-item-1-top">
          <img class="about-item-1-top-img" src="https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/about/triangle.png" />
          <p class="about-item-1-top-text">ABOUT US</p>
        </div>
        <p class="about-item-1-content">「秘密皮卡」MINI PIKA是广州时光之城科技有限公司旗下的智慧科技护肤品牌。公司立志于整合应用物联网技术、AI算法、皮肤学科研力量以及全球一流品牌的供应链体系资源，打造本土媲美国际一线大牌的“高品质、高颜值、高功效”的智慧科技护肤品牌。</p>
      </div>
      <div class="about-item-2">
        <div class="about-item-2-img" id="idea"></div>
        <p class="about-item-2-title">MINIPIKA</p>
        <p class="about-item-2-desc">始终为保持少年之心的用户， 提供梦幻、高效的智能科技护肤品牌</p>
        <div class="about-item-2-content" id="vision">
          <div class="about-item-2-content-detail">
            <img class="about-item-2-content-detail-img" src="https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/about/angle.png" />
            <p class="about-item-2-content-detail-title">品牌含义</p>
            <p class="about-item-2-content-detail-desc">创始人以其女儿的小名命名的品牌「秘密皮卡」MINI PIKA——生命的意义在于，去创造和经历美好。「心里有火，眼里有光，不惧风霜，让人生的每一个阶段，都是到目前为止，最好的阶段。」</p>
          </div>
          <div class="about-item-2-content-detail">
            <img class="about-item-2-content-detail-img" src="https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/about/angle.png" />
            <p class="about-item-2-content-detail-title">品牌理念</p>
            <p class="about-item-2-content-detail-desc">本分、知行合一、与时俱进。</p>
          </div>
          <div class="about-item-2-content-detail">
            <img class="about-item-2-content-detail-img" src="https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/about/angle.png" />
            <p class="about-item-2-content-detail-title">品牌愿景</p>
            <p class="about-item-2-content-detail-desc">无论什么年龄阶段的人，内心都住着一个少年，我们始终保持赤子之心，应用科技力量，为我们的目标用户，提供智能科技护肤产品，让他们能够从容、优雅地享受时间。</p>
          </div>
        </div>
      </div>
      <div class="about-item-3" id="story">
        <p class="about-item-3-title1">{{ item3List[item3Index].year }}</p>
        <p class="about-item-3-title2">{{ item3List[item3Index].day }}</p>
        <el-carousel 
        :initial-index="2"
        :interval="4000" 
        indicator-position="none"
        @change="swiperChange"
        type="card" 
        height="3.1rem">
          <el-carousel-item 
          v-for="item in item3List" 
          :key="item.path"
          :style="[{'--index': item.zIndex, '--left': item.mLeft, '--scale': item.scale}]" 
          >
            <div :style="{
              'background-image': `url(${item.path})`
            }" class="about-item-3-swiper-img">
              <div v-if="item.zIndex <= 0" class="about-item-3-swiper-img-mask"></div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="about-item-3-content">
          <img class="about-item-3-content-img" src="https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/about/left-arrow.png" />
          <p class="about-item-3-content-desc">{{ item3List[item3Index].desc }}</p>
          <img class="about-item-3-content-img" src="https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/about/right-arrow.png" />
        </div>
      </div>
      <mini-menu color="#3D3D3D" sub-color="#2D1D64" title="关于我们" />
    </div>
  </template>
   
  <script>
  import MiniMenu from "../components/MiniMenu.vue";
  export default {
    name: "About",
    components: {
      MiniMenu,
    },
    data() {
      return {
        item3List: [
          {year: '2022', day: '三月八日', path: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/about/item4.png", zIndex: 0, mLeft: -1.1125, scale: 0.8, desc: 'DAILY DOLLY奢华养护系列入选腾讯星选礼品，成为腾讯北上广深四地总部三八女神节员工福利礼品。'},
          {year: '2021', day: '六月十八日', path: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/about/item5.png", zIndex: 0, mLeft: 0.829, scale: 0.9, desc: '推出第一款测试产品时间旅人闪耀臻萃洗护系列，后正式产品升级为DAILY DOLLY奢华养护系列。'},
          {year: '2024', day: '六月九日', path: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/about/item1.png", zIndex: 1, mLeft: 2.947, scale: 1, desc: 'DAILY DOLLY奢华养护系列入驻深圳电台FM94.2《边听边买》节目。'},
          {year: '2023', day: '六月一日', path: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/about/item2.png", zIndex: 0, mLeft: 5.278, scale: 0.9, desc: '正式推出【重磅产品】:「秘密皮卡」MINIPIKA智能美容仪+线上交互平台。'},
          {year: '2023', day: '三月八日', path: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/about/item3.png", zIndex: 0, mLeft: 7.401, scale: 0.8, desc: '推出「秘密皮卡」MINIPIKA极境焕能系列和【爆款】「秘密皮卡」MINIPIKA高保湿水光弹冻干面膜。'},
        ],
        item3Index: 2,
      }
    },
    methods: {
      swiperChange(pre, next) {
        this.item3Index = next
        const list = this.item3List
        let isLeft = pre > next
        if (pre === this.item3List.length - 1 && next === 0) {
          isLeft = false
        } else if (pre === 0 && next === this.item3List.length - 1) {
          isLeft = true
        }
        if (!isLeft) {
          const mLeft = this.item3List[0].mLeft
          const zIndex = this.item3List[0].zIndex
          const scale = this.item3List[0].scale
          for (let i = 1; i < this.item3List.length; i++) {
            list[i - 1].mLeft = this.item3List[i].mLeft
            list[i - 1].zIndex = this.item3List[i].zIndex
            list[i - 1].scale = this.item3List[i].scale
          }
          list[this.item3List.length - 1].mLeft = mLeft
          list[this.item3List.length - 1].zIndex = zIndex
          list[this.item3List.length - 1].scale = scale
        } else {
          const mLeft = this.item3List[this.item3List.length - 1].mLeft
          const zIndex = this.item3List[this.item3List.length - 1].zIndex
          const scale = this.item3List[this.item3List.length - 1].scale
          for (let i = this.item3List.length - 1; i > 0; i--) {
            list[i].mLeft = this.item3List[i - 1].mLeft
            list[i].zIndex = this.item3List[i - 1].zIndex
            list[i].scale = this.item3List[i - 1].scale
          }
          list[0].mLeft = mLeft
          list[0].zIndex = zIndex
          list[0].scale = scale
        }
        this.item3List = list
      }
    },
    mounted() {
      this.$nextTick(() => {
        const arr = document.getElementsByClassName('el-carousel__mask')
        for (let i = 0; i < arr.length; i ++) {
          arr.item(i).style.backgroundColor = 'transparent'
        }
      })
    }
  };
  </script>
   
  <style lang="scss" scoped>
  .about {
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    overflow-x: hidden;
    position: relative;
    &-video {
      width: 100%;
      aspect-ratio: 1920/1082;
      background-color: #969696;
    }
    &-item-1 {
      width: 100%;
      aspect-ratio: 1920/891;
      background-image: url("https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/about/bg1.png");
      background-size: cover;
      background-position: 50% 50%;
      background-repeat: no-repeat;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      padding-left: 50%;
      padding-right: 8%;
      box-sizing: border-box;
      overflow: hidden;
      &-top {
        display: flex;
        flex-direction: row;
        align-items: center;
        &-img {
          width: 0.09rem;
          height: 0.17rem;
        }
        &-text {
          margin-left: 0.1rem;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 600;
          font-size: 0.26rem;
          color: #ffffff;
          line-height: 0.32rem;
        }
      }
      &-content {
        width: 100%;
        margin-top: 0.1rem;
        word-wrap: break-word;
        text-indent: 2ch;
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 400;
        font-size: 0.18rem;
        color: #ffffff;
        line-height: 0.25rem;
      }
    }
    &-item-2 {
      width: 100%;
      background-image: url("https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/about/bg2.png");
      background-size: cover;
      background-position: 50% 50%;
      background-repeat: no-repeat;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      padding-left: 0.45rem;
      padding-top: 0.3rem;
      padding-bottom: 0.3rem;
      box-sizing: border-box;
      overflow: hidden;
      &-img {
        position: absolute;
        left: 0;
        width: 100%;
        top: 0;
        height: 100%;
        background-image: url("https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/about/white.png");
        background-size: 100% 100%;
        background-position: 50% 50%;
        background-repeat: no-repeat;
      }
      &-title {
        z-index: 1;
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 600;
        font-size: 0.5rem;
        color: #4D3899;
        line-height: 0.71rem;
        word-break: keep-all;
      }
      &-desc {
        z-index: 1;
        margin-top: 0.4rem;
        width: 3.86rem;
        word-wrap: break-word;
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 600;
        font-size: 0.23rem;
        color: #4D3899;
        line-height: 0.32rem;
      }
      &-content {
        z-index: 1;
        margin-top: 0.4rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        overflow-x: scroll;
        &-detail {
          width: 2.2rem;
          height: 2.4rem;
          display: flex;
          flex-direction: column;
          padding-left: 0.23rem;
          padding-right: 0.13rem;
          box-sizing: border-box;
          box-shadow: -4px 4px 10px 0px rgba(0,0,0,0.3);
          overflow: hidden;
          &-img {
            width: 0.31rem;
            height: 0.31rem;
            margin-left: -0.23rem;
          }
          &-title {
            width: 100%;
            font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
            font-weight: 500;
            font-size: 0.2rem;
            color: #4D3899;
            line-height: 0.31rem;
          }
          &-desc {
            margin-top: 0.06rem;
            margin-bottom: 0;
            width: 100%;
            word-wrap: break-word;
            font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
            font-weight: 400;
            font-size: 0.16rem;
            color: #4D3899;
            line-height: 0.22rem;
          }
        }
      }
    }
    &-item-3 {
      width: 100%;
      aspect-ratio: 1920/1045;
      background-color: #2D1D64;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-bottom: 0.71rem;
      &-title1 {
        margin-top: 0.65rem;
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 600;
        font-size: 0.31rem;
        color: #FFFFFF;
        line-height: 0.43rem;
        text-align: center;
      }
      &-title2 {
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 600;
        font-size: 0.16rem;
        color: #FFFFFF;
        line-height: 0.28rem;
        text-align: center;
      }
      &-content {
        z-index: 2;
        margin-top: 0.26rem;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: center;
        overflow: visible;
        &-img {
          width: 0.5rem;
          height: 0.2rem;
        }
        &-desc {
          margin-top: -0.1rem;
          margin-left: 0.1rem;
          margin-right: 0.1rem;
          width: 2.8rem;
          word-wrap: break-word;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 400;
          font-size: 0.16rem;
          color: #FFFFFF;
          line-height: 0.26rem;
        }
      }
    }
    .el-carousel {
      width: 100%;
      margin-top: 0.1rem;
    }
    .el-carousel__item {
      width: 1.9rem;
      height: 100%;
      z-index: calc(var(--index) + 1);
      margin-left: calc((var(--left)) * 1rem);
      transform-origin: left center;
      transform: scale(var(--scale)) !important;
      .about-item-3-swiper-img {
        width: 100%;
        height: 100%;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        &-mask {
          width: 100%;
          height: 100%;
          background-color: black;
          opacity: 0.8;
        }
      }
    }
  }
  </style>